import { useCallback, useMemo, useState } from "react";

export type Disclosure = {
	isOpen: boolean;
	open: () => void;
	close: () => void;
	toggle: () => void;
};

/** Estado aberto/fechado para menu lateral, busca e afins. */
export function useDisclosure(initial = false): Disclosure {
	const [isOpen, setIsOpen] = useState(initial);

	const open = useCallback(() => setIsOpen(true), []);
	const close = useCallback(() => setIsOpen(false), []);
	const toggle = useCallback(() => setIsOpen((value) => !value), []);

	return useMemo(
		() => ({ isOpen, open, close, toggle }),
		[isOpen, open, close, toggle],
	);
}
